import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

//import all languages
import en from "./languages/en";
import hi from "./languages/hi";
import es from "./languages/es";

i18n.init({
    // we init with resources
    resources: {
        en: en,
        hi: hi,
        es: es,
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ','
    },

    react: {
        wait: true
    }
});

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js